<template>
    <BreadcrumbVue />
    <section class="camaras mb-5">
        <div class="container">
            <div class="row flex-column align-items-center">
                <h2>Camaras Permanentes</h2>
                <div class="col-lg-6 mt-4" v-for="(camara, index) in camaras.camaras_permanentes" :key="index">
                    <h3 class="titulo-camara mt-2 mb-3">{{ camara.titulo_camara }}</h3>
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Membro</th>
                                    <th>N° Registro</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(membro, i) in camara.tabela_de_membros" :key="i">
                                    <td>{{ membro.membro }}</td>
                                    <td>{{ membro.numero_de_registro }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <h2>Camaras Temporárias</h2>
                <div class="col-lg-6 mt-4" v-for="(camara, index) in camaras.camaras_temporarias" :key="index">
                    <h3 class="titulo-camara mt-2 mb-3">{{ camara.titulo_camara }}</h3>
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Membro</th>
                                    <th>N° Registro</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(membro, i) in camara.tabela_de_membros" :key="i">
                                    <td>{{ membro.membro }}</td>
                                    <td>{{ membro.numero_de_registro }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <svg xmlns="http://www.w3.org/2000/svg" width="1411" height="216" viewBox="0 0 1411 216" fill="none"
        preserveAspectRatio="none">
        <path
            d="M-1.63184 215.837L1412.09 215.837L1412.09 200.647C952.93 -59.9253 493.774 -71.6101 -1.63184 200.647L-1.63184 215.837Z"
            fill="#EEEEEE" fill-opacity="0.8" />
    </svg>
    <Popup />
    <FooterInternas />
</template>

<script>
import axios from 'axios';

const urlcamaras = 'https://api.cref20.org.br/wp-json/cref/v1/camaras-tecnicas';

import FooterInternas from '../components/FooterInternas/FooterInternas.vue';
import BreadcrumbVue from '@/components/Breadcrumb/Breadcrumb.vue';
import Popup from '@/components/Popup/PopupComponent.vue';
export default {
    name: 'CamarasTecnicas',
    components: {
        FooterInternas,
        BreadcrumbVue,
        Popup
    },
    data() {
        return {
            camaras: []
        }
    },
    mounted() {
        axios.get(urlcamaras).then((response) => {
            console.log(response.data.acf_campos)
            this.camaras = {
                camaras_permanentes: response.data.acf_campos.camara_permanentes,
                camaras_temporarias: response.data.acf_campos.camaras_temporarias
            }
        })
    }
}
</script>

<style scoped>
.camaras h2 {
    width: auto;
    margin-top: 38px;
    color: #313131;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.camaras h3 {
    text-align: center;
    color: #313131;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.camaras table.table-bordered {
    border-left: none;
    border-right: none;
    border-top: none;
    border-bottom: none;
}

.camaras table.table-bordered thead th {
    background: #12565f;
    color: white;
}

.camaras table.table-bordered tbody tr:nth-child(odd) td {
    background-color: #ffffff;
    /* Cor para linhas ímpares */
}

.camaras table.table-bordered tbody tr:nth-child(even) td {
    background-color: #E7E7E7;
    /* Cor para linhas pares */
}

.camaras table.table-bordered tbody,
.camaras table.table-bordered tbody tr,
.camaras table.table-bordered thead,
.camaras table.table-bordered thead tr,
.camaras table.table-bordered thead th {
    border-left: none;
    border-right: none;
    border-top: none;
    border-bottom: none;
}

.camaras table.table-bordered tbody td {
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid #dee2e6 !important;
}


svg {
    width: 100%;
}

@media (max-width: 765px) {
    svg {
        display: none;
    }
}
</style>